import React from 'react';
import { Link } from 'react-router-dom';
import '../assets/styles/CTASection.css';
import '../assets/styles/EnhancedCTA.css';

interface CTASectionProps {
  title: string;
  description: string;
  buttonText: string;
  buttonLink: string;
}

const CTASection: React.FC<CTASectionProps> = ({
  title,
  description,
  buttonText,
  buttonLink
}) => {
  const ctaSectionStyle = {
    backgroundColor: 'var(--light)',
    color: 'var(--dark)',
    backgroundImage: 'linear-gradient(to bottom right, rgba(0, 105, 74, 0.12), var(--light), rgba(179, 150, 86, 0.12))',
    borderTop: '1px solid rgba(179, 150, 86, 0.3)',
    borderBottom: '1px solid rgba(179, 150, 86, 0.3)'
  };

  return (
    <section className="cta-section" style={ctaSectionStyle}>
      <div className="container">
        <div className="cta-wrapper">
          <div className="cta-content">
            <h2>{title}</h2>
            <p>{description}</p>
            <p className="cta-highlight">
              With our newly unveiled Agentic Bot integrated into Price on Rails, we're empowering traders 
              to streamline execution while retaining intuitive control. The result is a platform that 
              stands unrivaled—delivering speed, precision, and a significant competitive edge.
            </p>
            <p className="cta-conclusion">
              If you're looking to harness AI-driven strategies without sacrificing clarity or control, 
              Translate Stocks is ready to lead you into the future of trading.
            </p>
            <div className="cta-actions">
              <Link to={buttonLink} className="btn btn-primary btn-large">
                {buttonText}
              </Link>
              <Link to="/demo" className="btn btn-outline btn-large">
                Watch Demo
              </Link>
            </div>
          </div>
          
          {/* <div className="cta-testimonial">
            <blockquote>
              "Price on Rails changed how I approach intraday trading. The predictive signals 
              have consistently helped me improve my win rate and maximize profitable trades."
            </blockquote>
            <div className="testimonial-author">
              <img 
                src="/images/trader-avatar.jpg" 
                alt="Professional Trader" 
                width="60" 
                height="60"
                loading="lazy"
              />
              <div className="author-info">
                <p className="author-name">Michael Raynor</p>
                <p className="author-title">Professional Trader, 8+ years</p>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default CTASection;
